import {Component, OnInit, inject} from '@angular/core';
import {SubjectFormBaseComponent} from '../subject-form-base.component';
import {UntypedFormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
import {phoneValidator} from '../../../_utils/validators';
import {NgClass} from '@angular/common';
import {PhoneFormRowComponent} from '../../../common/forms/phone-form-row/phone-form-row.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-dirs-lookup-form',
    templateUrl: './dirs-lookup-form.component.html',
    styleUrls: ['./dirs-lookup-form.component.scss'],
    imports: [ReactiveFormsModule, NgClass, PhoneFormRowComponent, TranslateModule]
})
export class DirsLookupFormComponent extends SubjectFormBaseComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);


  constructor() {
    super();
    const formBuilder = this.formBuilder;

    this.f = formBuilder.group({
      phone: ['', Validators.compose([Validators.required, Validators.maxLength(10), phoneValidator])]
    });
  }

  ngOnInit(): void {
  }

}
